<template>
  <div class="outer-box">
    <div v-if="isPopupOpen" class="popup" @enter="closePopup">
      <div class="popup-content">
        <span class="close-icon" @click="closePopup">&times;</span>
        <h3>{{ company }}</h3>
        <form>
          <div class="form-row">
            <label for="agencyEmail">Agency Email:</label>
            <input id="agencyEmail" v-model="agencyEmail" readonly class="hl_input--wrap w-auto" />
          </div>
          <div class="form-row">
            <label for="relationshipNumber">Relationship Number:</label>
            <input
              id="relationshipNumber"
              v-model="relationshipNumber"
              readonly
              class="hl_input--wrap w-auto"
            />
          </div>
        </form>
        <p>Type confirm to release all numbers associated with {{ company }}</p>
        <input
          type="text"
          v-model="confirmationText"
          placeholder="Type 'confirm'"
          class="hl_input--wrap w-auto"
        />
        <br />
        <br />
        <button :disabled="submitDisabled" class="btn btn-primary" @click="handleConfirmation">
          Submit
        </button>
      </div>
    </div>
    <h4>Release Numbers for the Agency</h4>
    <div class="inner-box" style="text-align: left; width: 500px">
      <b-alert show variant="danger">
        Debit Agency Wallet had been moved under -> Wallet
        <br />
      </b-alert>
      <div>Relationship Number</div>
      <input
        class="hl_input--wrap"
        type="text"
        placeholder="Relationship Number"
        v-model="relationshipNumber"
      />
      <br />
      <br />
      <!-- <div>Debit Amount</div>
      <input class="hl_input--wrap" type="text" placeholder="Debit Amount" v-model="amount" />
      <br />
      <br /> -->
      <div>Ticket Number</div>
      <input
        class="hl_input--wrap"
        type="text"
        placeholder="Ticket Number (Optional)"
        v-model="ticketNumber"
      />

      <br />
      <br />
      <template>
        <div>
          <input type="checkbox" :checked="isChecked" @click="toggleCheckbox" :disabled="true" />
          Release Numbers
        </div>
      </template>
      <!--TODO Need the AccountSID and Auth Token field -->
      <button :disabled="disabled || processing" class="btn btn-danger mt-4" @click="debitAmount">
        <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
        <span v-else> Release Numbers</span>
      </button>
      <pre v-if="response" style="background-color: #f2f7fa; padding: 16px; margin-top: 16px">{{
        response
      }}</pre>
    </div>
  </div>
</template>

<script>
import { SaasService, SpmAppengineService } from "@/services";
import { get } from "lodash";

export default {
  data() {
    return {
      ticketNumber: "",
      relationshipNumber: "",
      amount: "",
      processing: false,
      response: null,
      isChecked: true,
      isPopupOpen: false,
      isLoading: false,
      confirmationText: "",
      company: "",
      agencyEmail: "",
    };
  },
  computed: {
    disabled() {
      if (
        this.relationshipNumber.trim().length <= 0 ||
        // this.amount.trim().length <= 0 ||
        this.ticketNumber.trim().length <= 0
      )
        return true;
      else return false;
    },
    submitDisabled() {
      if (this.confirmationText.toLowerCase() === "confirm") return false;
      else return true;
    },
  },
  methods: {
    handleConfirmation() {
      if (this.confirmationText.toLowerCase() === "confirm") {
        // User confirmed, do something here
        this.debitAmountAndReleaseNumbers();
      } else {
        this.response = `Entered wrong text ${this.confirmationText}.
Please enter confirm to proceed.`;
      }
      this.closePopup();
    },
    closePopup() {
      this.isPopupOpen = false;
      this.confirmationText = "";
    },
    openPopup() {
      this.isPopupOpen = true;
    },
    toggleCheckbox() {
      this.isChecked = !this.isChecked;
    },

    async debitAmountAndReleaseNumbers() {
      try {
        this.processing = true;
        const responseData = await SaasService.isvCloseAgency(this.relationshipNumber, {
          // amount: parseFloat(this.amount),
          ticketNumber: this.ticketNumber,
          releaseNumbers: this.isChecked ?? true,
        });
        this.response = responseData.data;
      } catch (err) {
        this.response = err.response.data;
      } finally {
        this.processing = false;
        // this.amount = "";
      }
    },

    debitAmount() {
      if (this.isChecked) {
        this.fetchLocationDetails();
      } else {
        this.debitAmountAndReleaseNumbers();
      }
    },
    async fetchLocationDetails() {
      this.processing = true;
      const responseData = await SpmAppengineService.getAgencies(this.relationshipNumber);
      this.processing = false;
      this.company = get(responseData, "data.data.0.name", "");
      // this.company = responseData?.data?.data[0]?.name
      this.agencyEmail = get(responseData, "data.data.0.email", "");
      // console.log(this.company, this.agencyEmail, '====')
      // this.agencyEmail = responseData?.data?.data[0]?.email
      this.openPopup();
    },
  },
};
</script>

<style>
.popup {
  position: fixed;
  top: 0; /* Position the popup at the top */
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-start; /* Align content to the top of the popup */
  padding-top: 20vh; /* Adjust the padding-top to give space from the top */
  z-index: 9999;
}

.popup-content {
  position: relative;
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  justify-content: left;
}

.close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  cursor: pointer;
}

.form-group {
  margin-bottom: 20px;
}

label {
  font-weight: bold;
  margin-right: 10px;
}

.w-auto {
  width: auto;
}

button {
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.form-row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
</style>
